export var DPI_CHARGES = "DPI_CHARGES";
export var DPI_DETAILS = "DPI_DETAILS";
